export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    base_to_fs_start: [
      0,
      2788.7755102040815,
    ],
    big_win: [
      4000,
      3617.9818594104313,
    ],
    button_spin: [
      9000,
      557.9138321995458,
    ],
    free_bet_big_win: [
      11000,
      1362.312925170068,
    ],
    free_bet_mega_win: [
      14000,
      2207.913832199548,
    ],
    free_bet_total_win: [
      18000,
      973.3560090702938,
    ],
    free_bet_ultra_win: [
      20000,
      1297.4149659863947,
    ],
    free_spin_ambient: [
      23000,
      39649.04761904762,
    ],
    free_spin_music: [
      64000,
      87918.5941043084,
    ],
    fs_end_to_base: [
      153000,
      3145.2834467120283,
    ],
    fs_game_to_fs_end: [
      158000,
      2228.1632653061365,
    ],
    fs_start_to_fs_game: [
      162000,
      1624.8299319727835,
    ],
    inside_buttons: [
      165000,
      226.43990929705637,
    ],
    main_ambient: [
      167000,
      105082.1768707483,
    ],
    main_music: [
      274000,
      166096.89342403624,
    ],
    mega_win: [
      442000,
      4696.5759637188285,
    ],
    outside_buttons: [
      448000,
      609.9092970521269,
    ],
    reel_spin: [
      450000,
      3001.9501133787116,
    ],
    reel_stop_01: [
      455000,
      166.8934240362887,
    ],
    reel_stop_02: [
      457000,
      138.11791383221816,
    ],
    reel_stop_03: [
      459000,
      132.92517006800608,
    ],
    reel_stop_04: [
      461000,
      146.30385487527064,
    ],
    reel_stop_05: [
      463000,
      140.8163265306257,
    ],
    scatter_stop: [
      465000,
      867.6870748299166,
    ],
    sticky_wild: [
      467000,
      2206.417233560103,
    ],
    tap_to_play: [
      471000,
      2394.3990929705024,
    ],
    total_win: [
      475000,
      1765.6689342403524,
    ],
    ultra_win: [
      478000,
      5221.451247165533,
    ],
    wild_stop: [
      485000,
      616.3265306122412,
    ],
  },
}
